export enum TemplateMessageSortBy {
  featured = 'featured',
  new = 'new',
  top = 'top'
}

export enum TemplateMessageSortDirection {
  asc = 'asc',
  desc = 'desc'
}

export enum SearchMessageType {
  Draft = 'Draft',
  Favorite = 'Favorite',
  FeedItem = 'FeedItem',
  MessageAppearance = 'MessageAppearance',
  MessageSetMessage = 'MessageSetMessage',
  Pick = 'Pick',
  TemplatedMessage = 'TemplatedMessage'
}

export enum TemplateDisplayType {
  flagship = 'flagship',
  note = 'note'
}

export enum DisplayType {
  flagship = 'flagship',
  note = 'note'
}
